import React from "react";
import { useState,useEffect } from "react";
import {
  Col,
  Row,
  Typography,
  Input,
  Select,
  Table,
  // message,
  Modal,
  DatePicker,
  Button,
  // Checkbox,
} from "antd";
import {SearchOutlined,
    FilterOutlined,
    DownloadOutlined,
    ReloadOutlined
} from "@ant-design/icons" ;
import { useDispatch, useSelector } from "react-redux";
import api from "../../helpers";
import * as projectAction from "../../store/Project/action";
import * as reportAction from "../../store/Reports/actions";
import * as employeeAction from '../../store/Employee/actions'
import moment from "moment/moment";
import MetaTags from "react-meta-tags";
import BreadcrumbComponent from "../../components/BreadCrumb";
const BCrumb = [{ to: "/", title: "Home" }, { title: "Project List" }];


const ProjectReport = ()=>{
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const specificDispatch = useDispatch();
  const [projectName, setProjectName] = useState(null);
  const [employees, setEmployees] = useState([])
  const [phaseTableData, setPhaseTableData] = useState([])
  const [projectstatus, setProjectstatus] = useState([]);
  const [resetLoading, setResetLoading] = useState(false);
  const [downloadLoader, setDownloadLoader] = useState(false)
  // const [searchInput, setSearchInput] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageSize,setPageSize] = useState(10);
  const [currentPage,setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState({
      limit: 10,
      page: 1,
    });
  const dispatch = useDispatch();
  const updatedList = useSelector((rep)=>rep.Reports);
  console.log(updatedList,"updatedlist");
  const {projectlist} = updatedList
  console.log(projectlist,"projectlist")
  const updatedDropdown = useSelector((ss)=>ss.Project);
  const employeeDropdown = useSelector((ss)=>ss.Employee);
  console.log(updatedDropdown,"updatedddd")
  console.log(updatedDropdown.dropdownlist,"dropdownList")

  const [totalCount,setTotalCount] = useState(projectlist.total);
  console.log(projectlist.total,"count")
  useEffect(() => {
      if (projectlist) {
        setTotalCount(projectlist?.total);
      }
    }, [projectlist]);


    const projectNameOption = updatedDropdown.projectlist  &&  updatedDropdown.projectlist?.length > 0 ?  updatedDropdown.projectlist.map((data)=>{
    return{
      label :data.projectName,
      value: data._id,
    }
  }) : []
  console.log(projectNameOption,"nameoptionss");

  const employeeOption = employeeDropdown.employee_list?.data  &&  employeeDropdown.employee_list?.data.length > 0 ?  employeeDropdown.employee_list?.data.map((data)=>{
    return{
      label :data.employeeName,
      value:  data._id,
    }
  }) : []
  // console.log(employeeOption,"empOpt")
  
  

useEffect(()=>{
    specificDispatch(reportAction.loadProjectList({
        limit:10,
        page:1,
        startDate:projectlistData.startDate,
        endDate:projectlistData.endDate,
      })
    )
    specificDispatch(projectAction.loadProjectDetails())
    specificDispatch(employeeAction.loadEmployee());
  },[specificDispatch]);

//  useEffect(()=>{
//      specificDispatch(projectAction.loadDropdownProject({
//        limit:10,
//        page:1,
//        status:"BOTH",
//      }))
//      specificDispatch()
//    },[specificDispatch]);

  const [projectlistData, setProjectListData] = useState({
    projectName:"",
    startDate:null,
    endDate:null,
  })
// console.log(projectName,"pN");

const handleSearch = () => {
        const payload = {
          search: searchInput,
        };
        console.log(payload,"payloadsearch")
        setSearchLoading(true);
    
        setTimeout(() => {
          setSearchLoading(false);
        }, 500);
        setSearchValue(payload);
        dispatch(reportAction.loadProjectList(payload));
      };

  const handleProjectNameChange = (value)=>{
   setProjectName(value);
  }

  const showModalOpen = (project) => {
  if (project.phases && project.phases.length > 0) {
    const data = project.phases.map((phaselist, index) => ({
      _id: phaselist._id || `${project._id}-${index}`,
      sno: index + 1,
      phases: phaselist.phase,
      startDate: moment(phaselist.startDate).format("DD/MM/YYYY") || "--",
      endDate: moment.utc(phaselist.endDate).format("DD/MM/YYYY") || "--",
      phaseStatus: phaselist.phaseStatus,
      developers: phaselist.developers?.join(", ") || "--",
      milestones: phaselist.milestones || "--",
    }));
    setPhaseTableData(data);
  } else {
    // message.warning("Oops! Phase not created");
    setPhaseTableData([]);
  }
  setIsModalOpen(true);
};

      const handleModalClose = () => {
      setIsModalOpen(false);
      setPhaseTableData([]);
      };

  
  function getWindowDimensions() {
      const { innerWidth: width, innerHeight: height } = window;
      return { width, height };
    }
  
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    );
  
    useEffect(() => {
      function handleResize() {
        setWindowDimensions(getWindowDimensions());
      }
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType });
    
        const a = document.createElement("a");
        a.download = fileName;
        a.href = window.URL.createObjectURL(blob);
        const clickEvt = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        a.dispatchEvent(clickEvt);
        a.remove();
      };
    
      const exportToCsv = async () => {
        setDownloadLoader(true);
        let searchFilter = {};
        if (projectlistData.startDate)
          searchFilter.startDate = projectlistData.startDate.format("YYYY-MM-DD");
        if (projectlistData.startDate)
          searchFilter.endDate = projectlistData.endDate.format("YYYY-MM-DD");
        try {
          const res = await api.post("/auth/employee/projectreport", searchFilter);
          const projects = res.data?.reports || [];
    
          const mappedData = projects.map((data, index) => {
           return {
              _id: data._id,
              sno: index + 1,
              projectCode:
                data.projectCode || "--",
              projectName:
                data.projectName || "--",
              budget:data.budget,
              projectStatus:data.projectStatus?.label,
              startDate: data.startDate? moment(data.startDate).format("DD/MM/YYYY"): "--",
              endDate: data.endDate ? moment(data.endDate).format("DD/MM/YYYY") : "--",
              noOfWorkers:data.noOfWorkers,
              teamDetails:data.teamDetails
            };
          });
    
          const headers = [
            "S.No",
            "ProjectCode",
            "ProjectName",
            "Budget",
            "ProjectStatus",
            "StartDate",
            "EndDate",
            "NoOfWorkers",
            "TeamDetails",
          ];
    
          const csvRows = mappedData.map((item) => [
            item.sno,
            item.projectCode,
            item.projectName,
            item.budget,
            item.projectStatus,
            item.startDate,
            item.endDate,
            item.noOfWorkers,
            item.teamDetails?.map(tmd=>tmd.employeeName || "--"),
          ]);
    
          const csvContent = [
            headers.join(","),
            ...csvRows.map((row) => row.join(",")),
          ].join("\n");
    
          downloadFile({
            data: csvContent,
            fileName: "project_report.csv",
            fileType: "text/csv",
          });
        } catch (error) {
          if (error) {
            setDownloadLoader(false);
          }
        } finally {
          setDownloadLoader(false);
        }
      };
  
  const handleDateChange = (name, value) => {
    setProjectListData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFilter = (e) => {
  e.preventDefault();
  setSearchLoading(true);

  const payload = {
    limit: 10,
    page: 1,
    projectName: projectName?.value || "",
    startDate: projectlistData.startDate ? projectlistData.startDate.format("YYYY-MM-DD") : null,
    endDate: projectlistData.endDate ? projectlistData.endDate.format("YYYY-MM-DD") : null,
    employees: employees.map(emp => emp.value) || [],
    projectStatus: projectstatus?.value || "",
    search: "",
  };

  console.log("Filter Payload:", payload);
  setSearchValue(payload);
  specificDispatch(reportAction.loadProjectList(payload));

  setTimeout(() => setSearchLoading(false), 500);
};

const handleReset = () => {
  setSearchLoading(true);

  setProjectName(null);
  setEmployees([]);
  setProjectstatus(null);
  setProjectListData({
    projectName: "",
    startDate: null,
    endDate: null
  });
  setTimeout(() => {
    const payload = {
      limit: 10,
      page: 1,
      projectName: "",
      startDate: null,
      endDate: null,
      employees: [],
      projectStatus: "",
      search: "",
    };
    setSearchValue(payload);
    specificDispatch(reportAction.loadProjectList(payload));

    setSearchLoading(false);
  }, 1000);
};



   
// const handleSearch = () => {
//     const payload = {
//       search: searchInput,
//     };
//     setSearchLoading(true);

//     setTimeout(() => {
//       setSearchLoading(false);
//     }, 500);
//     dispatch(reportAction.loadProjectList(payload));
//   };

  const phaseColumns = [
    {
      title:(
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.sno - b.sno,
    },{
    title:"Phase",
      dataIndex: "phases",
      width: 70,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.sno - b.sno,
    },
    {
        title: "start Date",
        dataIndex: "startDate",
        className: "poppins-txt-lg",
        sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
      },
      {
        title: "end Date",
        dataIndex: "endDate",
        className: "poppins-txt-lg",
        sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
      },
      {
        title: "phase Status",
        dataIndex: "phaseStatus",
        className: "poppins-txt-lg",
        sorter: (a, b) => a.phaseStatus.localeCompare(b.phaseStatus),
      },
      {
        title: "Developers",
        dataIndex: "developers",
        className: "poppins-txt-lg",
        render: (developers) => (
      <span>
      {developers && developers.length > 0 ? developers: "--"}
      </span>
      ),
      },
      {
      title: "Milestones",
      dataIndex: "milestones",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.milestones.localeCompare(b.milestones),
      },
  ]

  const columns = [
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          S.No
        </span>
      ),
      dataIndex: "sno",
      width: 70,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.sno - b.sno,
    },
    {
      title: (
        <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
          Project Code
        </span>
      ),
      dataIndex: "projectCode",
      width: 160,
      className: "poppins-txt-lg",
      sorter: (a, b) => a.projectCode.localeCompare(b.projectCode),
    },
    {
      title: "Project Name",
      dataIndex: "projectName",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.projectName.localeCompare(b.projectName),
    },
    {
      title: "Budget",
      dataIndex: "budget",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.budget.localeCompare(b.budget),
    },
    {
      title: "Project Status",
      dataIndex: "projectStatus",
      className: "poppins-txt-lg",
      render: (text) => text || "--",
      sorter: (a, b) => a.projectStatus.localeCompare(b.projectStatus),
    },
    {
      title: "No.of.Workers",
      dataIndex: "noOfWorkers",
      className: "poppins-txt-lg",
      sorter: (a, b) => a.noOfWorkers - b.noOfWorkers,
    },
    {
  title: "Phase",
  dataIndex: "phases",
  className: "poppins-txt-lg",
  render: (_, record) => (
    <div
      style={{
        display: "inline-block",
        padding: "3px 8px",
        border: "1px solid #1890ff",
        borderRadius: "6px",
        cursor: "pointer",
        backgroundColor: "#e6f7ff",
        color: "#1890ff",
        fontWeight: "500",
        fontSize: "14px",
        textAlign: "center"
      }}
      onClick={() => showModalOpen(record)}
    >
      View Phase
    </div>
  ),
},
    {
        title: "Start Date",
        dataIndex: "startDate",
        className: "poppins-txt-lg",
        sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
      },
      {
        title: "End Date",
        dataIndex: "endDate",
        className: "poppins-txt-lg",
        sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
      },
      {
      title: "Developers",
      dataIndex: "teamDetails",
      className: "poppins-txt-lg",
      render: (teamDetails) => (
        <span>
          {teamDetails && teamDetails.length > 0
            ? teamDetails.map(emp => emp.employeeName).join(", ")
            : "--"}
        </span>
      ),
      },
  ];

  const tableData = updatedList.projectlist.reports?updatedList.projectlist.reports.map((data,index)=>{
    return{
        _id: data._id,
        sno: index + 1,
        projectCode:data.projectCode|| "--",
        projectName:data.projectName || "--",
        budget:data.budget,
        projectStatus: data.projectStatus?.label || "--",
        noOfWorkers:data.noOfWorkers,
        startDate: moment(data.startDate).format("DD/MM/YYYY") || "--",
        endDate: moment.utc(data.endDate).format("DD/MM/YYYY") || "--",
        teamDetails:data.teamDetails,
        phases: data.phases || [],
    }
  }):[]


    return(
        <React.Fragment>
            <div className="pl-5">
                    <MetaTags>
                      <title>Project List | Mequals</title>
                    </MetaTags>
                  </div>
                  <Row justify="space-between" className="mr-4">
        <Col>
          <BreadcrumbComponent title="Project List" items={BCrumb} />
        </Col>
      </Row>

      <div
              style={{
                background: "#ffffff",
                margin: "4px 8px 4px 8px",
                padding: "16px",
                borderRadius: "8px 8px 0px 0px",
              }}
            >
              <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                <div className="mb-2">
                  <Typography className="poppins-txt">Project Name</Typography>
                </div>
                <Select
                  placeholder="Select Project Name"
                  allowClear
                  className="custom-select"
                  name="projectName"
                  value={projectName}
                  onChange={(values,selectedoptions)=>{
                      setProjectName(selectedoptions || [])
                    }}
                  options={projectNameOption}
                  autoComplete="off"
                />
              </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <div>
                    <div className="mb-2">
                      <Typography className="poppins-txt">Start Date</Typography>
                    </div>
                    <DatePicker
                      className="custom-select py-2"
                      name="fromDate"
                      value={projectlistData.startDate}
                      onChange={(date) => handleDateChange("startDate", date)}
                      // maxDate={projectlistData.startDate}
                    />
                  </div>
                </Col>
      
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <div>
                    <div className="mb-2">
                      <Typography className="poppins-txt">End Date</Typography>
                    </div>
                    <DatePicker
                      className="custom-select py-2"
                      name="toDate"
                      value={projectlistData.endDate}
                      onChange={(date) => handleDateChange("endDate", date)}
                      // minDate={projectlistData.endDate}
                    />
                  </div>
                </Col>
      
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <div className="mb-2">
                    <Typography className="poppins-txt">Employees</Typography>
                  </div>
                  <Select
                    mode="multiple"
                    placeholder="Select Employees"
                    allowClear
                    className="custom-select"
                    name="employees"
                    value={employees}
                    onChange={(values,selectedoptions)=>{
                      setEmployees(selectedoptions || []);
                    }}
                    options={employeeOption}
                    autoComplete="off"
                    dropdownRender={(menu) => (
                      <h1 className="option-text-font">{menu}</h1>
                    )}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <div className="mb-2">
                    <Typography className="poppins-txt">Project Status</Typography>
                  </div>
                  <Select
                    placeholder="Select Project status"
                    allowClear
                    className="custom-select"
                    name="designation"
                    value={projectstatus}
                    onChange={(values,selectedoptions)=>{
                      setProjectstatus(selectedoptions || [])
                    }}
                    options={updatedDropdown.dropdownlist.projectStatusOptions}
                    autoComplete="off"
                    dropdownRender={(menu) => (
                      <h1 className="option-text-font">{menu}</h1>
                    )}
                  />
                </Col>
              </Row>
      
              <Row justify="end" style={{ marginTop: "8px" }}>
                <Col>
                  <Button
                    className="custom-btn"
                    icon={<ReloadOutlined style={{ fontSize: "16px" }} />}
                    size="middle"
                    onClick={handleReset}
                    loading={resetLoading}
                    danger
                    style={{ marginRight: "12px" }}
                  >
                    Reset
                  </Button>
                  <Button
                    className="custom-btn"
                    type="primary"
                    size="middle"
                    icon={<FilterOutlined style={{ fontSize: "18px" }} />}
                    htmlType="submit"
                    onClick={handleFilter}
                    loading={searchLoading}
                  >
                    Apply Filter
                  </Button>
                </Col>
              </Row>
            </div>
            <Row justify="space-between"
            align="middle"
            style={{ marginBottom: 10 }}
            >
              <Col>
                <Input
                  placeholder="Search..."
                  allowClear
                  style={{ width: 250, fontFamily: "Poppins" }}
                  name="searchInput"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  type="text"
                  autoComplete="off"
                />
                
                <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  style={{ marginLeft: 8 }}
                  onClick={handleSearch}
                />
                </Col>
                <Col>
                <Button
                  className="custom-btn"
                  size="medium"
                  type="primary"
                  icon={<DownloadOutlined />}
                  loading={downloadLoader}
                  onClick={exportToCsv}
                >
                  Download
                </Button>
                </Col>
                </Row>

            <Table
                      columns={columns}
                      loading={searchLoading}
                      dataSource={tableData}
                      className="poppins-txt"
                      rowKey={(record) => record._id}
                      rowClassName={"text-[12px]"}
                      pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalCount,
                      showSizeChanger: true,
                      pageSizeOptions: ["5", "10", "20", "30"],
                      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                      }}
                      sortDirections={["ascend", "descend"]}
                      showSorterTooltip={"sorter-icon"}
                      scroll={{
                        x: 765,
                      }}
                      onChange={(pagination, filters, sorter) => {
                      const { current, pageSize } = pagination;
                      setCurrentPage(current);
                      setPageSize(pageSize);
                      const updatedParams = {
                        ...searchValue,
                        page: current,
                        limit: pageSize,
                      };
            
                        setSearchValue(updatedParams);
                        specificDispatch(
                        reportAction.loadProjectList(updatedParams)
                        );
                      }}
                    />

          <Modal
                open={isModalOpen}
                onCancel={handleModalClose}
                title={
                <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "19px",
                }}
                className="poppins-txt"
                >
                  <span>Phase Data</span>
              </div>
              }
              className="poppins-txt custom-active-modal"
              centered
              maskClosable={false}
              footer={null}
              width="75vw"
              // height="590px"
              maxWidth="1200px"
              style={{
              padding: 0,
              justifyContent:"center",
              flexDirection:"column",
              // height:"590px",
              marginLeft: windowDimensions.width > 992 ? "220px" : "0",
              }}
              >
                <Table 
                columns={phaseColumns}
                loading={searchLoading}
                dataSource={phaseTableData}
                className="poppins-txt"
                rowClassName={"text-[12px]"}
                scroll={{
                x: 765,
                }}
                />
              </Modal>

        </React.Fragment>
    )
}

export default ProjectReport;